import React from "react";
import { useState } from 'react';
import { Helmet } from "react-helmet";
import { NavLink } from 'react-router-dom';


function PyOpti()
{
    return (
        <div>
            <Helmet>
                <title>Python Optimization| Lucas RODRIGUEZ</title>
            </Helmet>
            <p><i className="fa fa-home"></i>&nbsp; <NavLink to="/">Home</NavLink></p>

            <h2>Python Optimization tracks</h2>

            <ul>
                <li>https://sunscrapers.com/blog/python-code-optimization-tips-for-experts/</li>
                <li>https://wiki.python.org/moin/PythonSpeed/PerformanceTips</li>
                <li>https://www.toucantoco.com/en/tech-blog/python-performance-optimization</li>
            </ul>
        </div >
    );
}
export default PyOpti;